module.exports = __webpack_public_path__ + "img/4.1fc905e3.svg";